import fs from 'fs'
import remark from 'remark'
import html from 'remark-html'
import PageContainer from '../components/PageContainer'

const Changelog = ({ content }) => {
  return (
    <PageContainer>
      <div
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </PageContainer>
  )
}

export default Changelog
export async function getStaticProps () {
  const logTxt = fs.readFileSync('./staticContent/changelog.md', 'utf8')
  const htmlString = (await remark()
    .use(html)
    .process(logTxt))
    .toString()

  return {
    props: {
      content: htmlString
    }
  }
}
